var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("div", { staticClass: "loginPageHeader" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { position: "fixed", right: "30px", top: "25px" } },
          [_c("lang-select")],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("h1", { staticClass: "loginWelcomeHeader" }, [
              _vm._v(_vm._s(_vm.$t("loginWelcomeHeader")))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "w-100 text-center" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mt-20",
                    attrs: { size: "small" },
                    on: { click: _vm.handleCognitoLoginParticipant }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("loginAsParticipant")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loginPageLogo pt-25 text-center" }, [
      _c("img", {
        attrs: { src: require("@/assets/risolto_logo_full.png"), height: "30" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }